import { useEffect, useRef } from "react";
import { useAppContext } from "../../../AppContext";
import { usePushNotifications } from "./usePushNotifications";

/**
 * Once per visit, after sign-in: moves a push service worker installed before deliveries
 * were confirmed onto the current script URL, so the studio sees "Получено" / "Отворено"
 * in the notification log. Never installs a worker for someone who has none.
 */
export const useServiceWorkerRefresh = () => {
  const { isAuthenticated } = useAppContext();
  const { refreshServiceWorker } = usePushNotifications();
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || hasRunRef.current) {
      return;
    }
    hasRunRef.current = true;
    refreshServiceWorker().catch(() => undefined);
  }, [isAuthenticated, refreshServiceWorker]);
};
